<h3 class="mb15">Your Plan is Not Supported</h3>
<p class="mb30">Your current plan does not support 10Web Booster,<br>
  follow this <a (click)="logout()">link</a> to log out & sign up with a new account.<br>
  If you have any questions please <a (click)="openChat()">contact us</a> via live chat.</p>
<button class="ds-btn-blue" (click)="close()"><span>Got It</span></button>
